// ════════════════════════════════════════════════════════════════
// api.js — Configuration URL Backend
// ════════════════════════════════════════════════════════════════

// Détermine automatiquement si on est sur localhost ou en ligne
const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

export const API_URL = isLocal 
  ? "http://localhost:8000" 
  : "https://agora-server-hgro.onrender.com";